exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 768px){.baner-carousel[data-v-736af319]{width:368px;margin:0 auto}}\n", ""]);

// exports
